import GitHubIcon from '@mui/icons-material/GitHub';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

export const skillsData = [
  {
    name: "ReactJs",
    width: "80%",
  },
  {
    name: "NodeJs",
    width: "70%",
  },
  {
    name: "MongoDb",
    width: "50%",
  },
  {
    name: "c++",
    width: "30%",
  },
  {
    name: "ExpressJs",
    width: "85%",
  },
  {
    name: "Sass",
    width: "80%",
  },
  {
    name: "Css",
    width: "90%",
  },
  {
    name: "JavaScript",
    width: "85%",
  },
  {
    name: "TypeScript",
    width: "60%",
  },
  {
    name: "Pwa",
    width: "50%",
  },
  {
    name: "Npm packages",
    width: "70%",
  },
  {
    name: "Node clis",
    width: "60%",
  },
  {
    name: "Mongoose",
    width: "65%",
  },
  {
    name: "Mui",
    width: "75%",
  },
];

export const conectData = [
  {
    name:"Twitter",
    icon:<TwitterIcon/>,
    url:"https://twitter.com/OmarAlghaish"
  },
  {
    name:"Github",
    icon:<GitHubIcon/>,
    url:"https://github.com/omar-alghaish"
  },
  {
    name:"Email",
    icon:<EmailIcon/>,
    url:"omaralghish@gmail.com"
  },
  {
    name:"Instagram",
    icon:<InstagramIcon/>,
    url:"https://www.instagram.com/omarelghish/"
  },
  {
    name:"Linkedin",
    icon:<LinkedInIcon/>,
    url:"https://www.linkedin.com/in/omar-alghaish-b90a22225/"
  },
  {
    name:"Facebook",
    icon:<FacebookIcon/>,
    url:"https://www.facebook.com/profile.php?id=100073854146166"
  },
]